import React from "react";
import { TableBody } from "@mui/material";

const DSTableBody = React.forwardRef<
  HTMLTableSectionElement,
  React.ComponentProps<typeof TableBody>
>((props, ref) => {
  return <TableBody ref={ref} {...props} />;
});

DSTableBody.displayName = "DSTableBody";

export default DSTableBody;
